// extracted by mini-css-extract-plugin
export default {"seatNumbers":"F5NnDYYdFenHjA9ju3WK"};